<script lang="ts">
import { defineComponent, VNode } from 'vue';

export default defineComponent({
  name: 'ModalOpener',
  emits: { close: null },

  render(): VNode {
    return this.$slots.default
      ? this.$slots.default({
          show: this.show,
          isShown: this.isShown,
        })[0]
      : null;
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    // eslint-disable-next-line vue/require-prop-types
    payload: {
      required: false,
      default: null,
    },

    stackable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data(): {
    unsubscribe: () => void;
  } {
    return {
      unsubscribe: () => {},
    };
  },

  computed: {
    isShown(): boolean {
      return Boolean(this.$store.state.modal.modals.find((modal) => modal.type === this.name));
    },
  },

  methods: {
    show(payload = null) {
      this.$store.dispatch('modal/show', {
        type: this.name,
        stackable: this.stackable,
        payload: payload || this.payload,
      });

      this.unsubscribe = this.$store.subscribe((mutation) => {
        if (mutation.type === 'modal/MODAL_HIDE' && mutation.payload.type === this.name) {
          this.$emit('close', mutation.payload);
          this.unsubscribe();
        }
      });
    },
  },

  unmounted() {
    this.unsubscribe();
  },
});
</script>
